'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_forms_BooleanInput_BooleanInput = require('./BooleanInput.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const Radio = (_a) => {
  var { tabIndex = 0 } = _a, otherProps = tslib_es6.__rest(_a, ["tabIndex"]);
  return React__default.default.createElement(components_forms_BooleanInput_BooleanInput.BooleanInput, Object.assign({ type: "radio", tabIndex }, otherProps));
};

exports.Radio = Radio;
//# sourceMappingURL=Radio.cjs.js.map
